import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import {
    SpsAdvancedSearchComponent,
    SpsAdvancedSearchFooterComponent,
    SpsListToolbarComponent,
    SpsSearchResultsBarComponent,
    SpsListToolbarSearchComponent,
} from "../components/index";
import { SpsDSCoreModule } from "./sps-ds-core.module";
import { SpsFormsModule } from "./sps-forms.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SpsDSCoreModule,
        SpsFormsModule
    ],
    declarations: [
        SpsAdvancedSearchComponent,
        SpsAdvancedSearchFooterComponent,
        SpsListToolbarComponent,
        SpsSearchResultsBarComponent,
        SpsListToolbarSearchComponent
    ],
    exports: [
        SpsAdvancedSearchComponent,
        SpsAdvancedSearchFooterComponent,
        SpsListToolbarComponent,
        SpsSearchResultsBarComponent,
        SpsListToolbarSearchComponent
    ]
})
export class SpsSearchModule { }
